import React from 'react';

const MyCapsoLogo = (props) => {
	const { width } = props;

	return (
			<img style={{width: width || 240}} draggable="false" src={process.env.PUBLIC_URL + '/MyCapso-logo.svg'} alt="MyCapso Logo" />
	)
}

export default MyCapsoLogo;